import React, { useEffect, useState } from "react";
import { Typography, IconButton } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SiTextField from "../../core/si-textfield";
import SiAutocomplete from "../../core/si-autocomplete";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { Icon } from "@iconify/react";
import moment from "moment";
const SERVICE_LIST = [
  { label: "1st Service", value: "firstService" },
  { label: "2nd Service", value: "secondService" },
  { label: "3rd Service", value: "thirdService" },
  { label: "4th Service", value: "fourthService" },
  { label: "5th Service", value: "fifthService" },
  { label: "6th Service", value: "sixthService" },
  { label: "7th Service", value: "seventhService" },
];

const style = {
  display: "flex",
  gridGap: 10,
  flexDirection: "column",
};

const FreeServices = ({
  onSave,
  serviceList,
  onDelete,
  error,
  formData = {},
}) => {
  const [serviceDetails, setServiceDetails] = useState({});
  const [addNew, setAddNew] = useState(false);
  const [isInValidServiceHour, setIsInValidServiceHour] = useState(false);
  const [isInvalidDate, setIsInvalidDate] = useState(false); // New state for date validation

  const onInputChange = (event) => {
    setServiceDetails({
      ...serviceDetails,
      [event.target.name]: event.target.value,
    });
  };

  const deleteRecord = (index) => {
    serviceList.splice(index, 1);
    onDelete([...serviceList]);
  };

  useEffect(() => {
    if (parseInt(serviceDetails?.runningHours) > parseInt(formData?.hmr)) {
      setIsInValidServiceHour(true);
    }
    if (parseInt(serviceDetails?.runningHours) <= parseInt(formData?.hmr)) {
      setIsInValidServiceHour(false);
    }
    const currentDate = new Date();
    const enteredDate = new Date(serviceDetails?.date);
    if (enteredDate > currentDate) {
      setIsInvalidDate(true);
    } else {
      setIsInvalidDate(false);
    }
  }, [serviceDetails, formData?.hmr]);

  return (
    <div>
      <div className="ph-header">
        <p
          style={
            error
              ? {
                  color: "red",
                }
              : {}
          }
          className="primary-text"
        >
          Service History
        </p>
        <IconButton onClick={() => setAddNew(true)}>
          <Icon
            icon="lets-icons:add-duotone"
            width="2rem"
            height="2rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
      </div>
      {addNew && (
        <div className="fs-row">
          <SiAutocomplete
            options={SERVICE_LIST.filter(
              (ss) => !serviceList.find((s) => s.name.value === ss?.value)
            )}
            value={serviceDetails.name}
            onChange={(value) =>
              setServiceDetails({ ...serviceDetails, name: value })
            }
            fullWidth
            placeholder="Service number"
          />

          <SiTextField
            name={"date"}
            placeholder="Date"
            type="date"
            onChange={onInputChange}
            value={serviceDetails.date || ""}
            error={isInvalidDate}
            helperText={isInvalidDate && "Date cannot be in the future"}
            InputProps={{
              inputProps: { max: new Date().toISOString().split("T")[0] },
            }}
          />
          <SiTextField
            name="runningHours"
            placeholder="Running Hours"
            type="number"
            onChange={onInputChange}
            value={serviceDetails.runningHours || ""}
            error={isInValidServiceHour}
            helperText={isInValidServiceHour && "Hours should be less than HMR"}
          />
          <SiTextField
            name="jobCardNumber"
            placeholder="Job card Number"
            type="text"
            onChange={onInputChange}
            value={serviceDetails.jobCardNumber || ""}
          />
          <div style={{ display: "flex", gap: "5px" }}>
            <IconButton
              disabled={
                !serviceDetails.name ||
                !serviceDetails.date ||
                !serviceDetails.runningHours ||
                isInValidServiceHour ||
                isInvalidDate
              }
              onClick={() => {
                onSave(serviceDetails);
                setAddNew(false);
                setServiceDetails({});
              }}
            >
              <CheckCircleOutlineOutlinedIcon />
            </IconButton>
            <IconButton onClick={() => setAddNew(false)}>
              <CancelOutlinedIcon />
            </IconButton>
          </div>
        </div>
      )}
      <div className="ph-table">
        {serviceList.length > 0 && (
          <div className="pht-header table-header-bg primary-text">
            <span>Service number</span>
            <span>Date</span>
            <span>Running Hours</span>
            <span>Job card number</span>
            <span>Actions</span>
          </div>
        )}
        {serviceList.map((item, index) => {
          return (
            <div className="pht-header" key={index}>
              <span>{item.name.label}</span>
              <span>{moment(item.date).format("DD-MM-YYYY")}</span>
              <span>{item.runningHours}</span>
              <span>{item.jobCardNumber}</span>
              <div className="actions">
                <IconButton
                  onClick={() => deleteRecord(index)}
                  sx={{ padding: "0px" }}
                >
                  <DeleteTwoToneIcon color="error" />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default FreeServices;
